import { APICore } from "./apiCore";

const api = new APICore();

const getAtendimentosColaborador = ((queryString?: string) => {
    return api.get(`/atendimento-colaborador${queryString ? queryString : ""}`)
})

export { getAtendimentosColaborador };